import { ETheme, EThemeBackground } from '@/common/entity/Enum';
import styled from 'styled-components';

export const ResourceSelectedBaseWrapper = styled.div`
  width: 100%;
  .nodata {
    margin-bottom: 15px;
  }
  .scrollable-content {
    overflow-y: auto;
    padding-right: 10px; // Add some padding to account for scrollbar
  }

  .ResourceInfoWrapper {
    margin-bottom: 10px;
  }
`;

export const ResourceInfoWrapper = styled.div`
  padding-left: 8px;
  padding-right: 8px;
  margin-bottom: 8px;

  &:last-child {
    margin-bottom: 16px;
  }
`;

export const StickyElementWrapper = styled.div<{ $theme?: string }>`
  height: 40px;
  margin-left: -2px;
  overflow-x: hidden;
  position: sticky;
  bottom: 0;
  padding: 0px 15px;
  border-bottom-right-radius: 8px;
  border-bottom-left-radius: 8px;
  background: ${props => props.$theme === ETheme.Dark ? EThemeBackground.Dark : EThemeBackground.Light};
`;

export const HeaderTitleWrapper = styled.div<{ $theme?: string }>`
  position: sticky;
  top: 0;
  background-color: ${props => props.theme?.backgroundColor || '#ffffff'};
  z-index: 1;
  padding: 10px 0;
  display: flex;
  align-items: center;

  span {
    margin-left: 10px;
  }
`;
